let googleTagLoaded = false;

function ensureDataLayer() {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
}

export function initGoogleConsentDefaults() {
  ensureDataLayer();

  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
  });
}

export function loadGoogleAnalytics() {
  if (googleTagLoaded) return;

  ensureDataLayer();

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-2LEHE9N9HD";
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", "G-2LEHE9N9HD", {
    anonymize_ip: true,
    send_page_view: false,
  });

  googleTagLoaded = true;
}

export function updateGoogleConsent(consent) {
  ensureDataLayer();

  window.gtag("consent", "update", {
    analytics_storage: consent?.analytics ? "granted" : "denied",
    ad_storage: consent?.marketing ? "granted" : "denied",
    ad_user_data: consent?.marketing ? "granted" : "denied",
    ad_personalization: consent?.marketing ? "granted" : "denied",
  });
}